// import { useState } from "react";
// import {
//     CubeIcon,
//     ShoppingCartIcon,
//     ArrowsRightLeftIcon,
//     ScaleIcon
// } from "@heroicons/react/24/outline";
// import SelfStockReport from "./Selfstockreport";
// import DailyPurchaseReport from "./DailyPurchaseReport";
// import DailySaudaReport from "./DailySaudaReport";
// import TrailBalanceReport from "./TrailBalanceReport";

// // Reusable Professional "Empty State"
// function ComingSoon({ title, description, icon: Icon }) {
//     return (
//         <div className="flex flex-col items-center justify-center py-24 px-6 text-center animate-in fade-in duration-700">
//             <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-5 border border-blue-100 shadow-sm">
//                 <Icon className="w-8 h-8 text-blue-300" />
//             </div>
//             <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
//             <p className="text-sm text-slate-500 max-w-sm mt-2 leading-relaxed">
//                 {description}
//             </p>
//             <div className="mt-8 inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-widest bg-blue-50 text-blue-700 border border-blue-200/50">
//                 <span className="relative flex h-2 w-2">
//                     <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
//                     <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
//                 </span>
//                 Feature in Development
//             </div>
//         </div>
//     );
// }

// const TABS = [
//     { id: "self-stock", label: "Self Stock Report", icon: CubeIcon },
//     { id: "daily-purchase", label: "Daily Purchase", icon: ShoppingCartIcon },
//     { id: "daily-sauda", label: "Daily Sauda", icon: ArrowsRightLeftIcon },
//     { id: "trial-balance", label: "Trial Balance", icon: ScaleIcon },
// ];

// export default function ClosingStock() {
//     const [active, setActive] = useState("self-stock");

//     const renderActiveContent = () => {
//         switch (active) {
//             case "self-stock":
//                 return <SelfStockReport />;
//             case "daily-purchase":
//                 return <DailyPurchaseReport />
//             case "daily-sauda":
//                 return <DailySaudaReport/>
//             case "trial-balance":
//                 return <TrailBalanceReport/>
//             default:
//                 return null;
//         }
//     };

//     return (
//         <div className="w-full  bg-slate-50/50 p-4 lg:p-8 " style={{marginTop:"-80px"}}>
//             <div className="mx-auto">
//                 <div className="bg-white rounded-3xl border border-slate-200 shadow-xl shadow-slate-200/50 overflow-hidden">

//                     {/* Navigation Tabs */}
//                     {/* Navigation Tabs */}
//                     <div className="bg-slate-50/80 border-b border-slate-200 px-6 pt-4">
//                         <nav
//                             className="flex gap-2 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
//                             aria-label="Tabs"
//                         >
//                             {TABS.map((tab) => {
//                                 const isActive = active === tab.id;
//                                 return (
//                                     <button
//                                         key={tab.id}
//                                         onClick={() => setActive(tab.id)}
//                                         className={`
//                                             flex-shrink-0 whitespace-nowrap group relative flex items-center gap-2.5 px-6 py-4 text-sm font-bold transition-all duration-300
//                                             rounded-t-xl border-x border-t -mb-px
//                                             ${isActive
//                                                 ? "bg-white border-slate-200 text-blue-600 shadow-[0_-4px_12px_rgba(0,0,0,0.02)]"
//                                                 : "bg-transparent border-transparent text-slate-500 hover:text-slate-800 hover:bg-slate-200/40"
//                                             }
//                                         `}
//                                     >
//                                         <tab.icon className={`w-5 h-5 transition-colors ${isActive ? "text-blue-600" : "text-slate-400 group-hover:text-slate-600"
//                                             }`} />
//                                         {tab.label}

//                                         {/* Top Glow Accent */}
//                                         {isActive && (
//                                             <span className="absolute top-0 left-0 right-0 h-1 bg-blue-600 rounded-full mx-2" />
//                                         )}
//                                     </button>
//                                 );
//                             })}
//                         </nav>
//                     </div>

//                     {/* Dynamic Content Area */}
//                     <div className="relative min-h-[600px]">
//                         {renderActiveContent()}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }





















import { useState } from "react";
import {
    CubeIcon,
    ShoppingCartIcon,
    ArrowsRightLeftIcon,
    ScaleIcon,
    CalendarDaysIcon,
    MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import SelfStockReport from "./Selfstockreport";
import DailyPurchaseReport from "./DailyPurchaseReport";
import DailySaudaReport from "./DailySaudaReport";
import TrailBalanceReport from "./TrailBalanceReport";

const todayISO = () => new Date().toISOString().slice(0, 10);

const TABS = [
    { id: "self-stock",      label: "Self Stock Report", icon: CubeIcon },
    { id: "daily-purchase",  label: "Daily Purchase And Sale",    icon: ShoppingCartIcon },
    // { id: "daily-sauda",     label: "Daily Sauda",       icon: ArrowsRightLeftIcon },
    { id: "trial-balance",   label: "Sundary Debtors",     icon: ScaleIcon },
];

export default function ClosingStock() {
    const [active, setActive]       = useState("self-stock");
    const [inputDate, setInputDate] = useState(todayISO());   // controlled input
    const [activeDate, setActiveDate] = useState(todayISO()); // committed date passed to children

    // Only commit date when user clicks "Get Report"
    const handleFetch = () => {
        if (inputDate) setActiveDate(inputDate);
    };

    const renderActiveContent = () => {
        switch (active) {
            case "self-stock":
                return <SelfStockReport toDate={activeDate} />;
            case "daily-purchase":
                return <DailyPurchaseReport toDate={activeDate} />;
            case "daily-sauda":
                return <DailySaudaReport toDate={activeDate} />;
            case "trial-balance":
                return <TrailBalanceReport toDate={activeDate} />;
            default:
                return null;
        }
    };

    return (
        <div className="w-full bg-slate-50/50 p-4 lg:p-8" style={{ marginTop: "-80px" }}>
            <div className="mx-auto">
                <div className="bg-white rounded-3xl border border-slate-200 shadow-xl shadow-slate-200/50 overflow-hidden">

                    {/* ── Date Bar ── */}
                    <div className="flex items-center gap-4 px-6 py-3 bg-gradient-to-r from-slate-800 to-slate-700 border-b border-slate-600">
                        <div className="flex items-center gap-2 text-slate-300">
                            <CalendarDaysIcon className="w-4 h-4" />
                            <span className="text-[11px] font-bold uppercase tracking-widest text-slate-400">As On Date</span>
                        </div>

                        <input
                            type="date"
                            value={inputDate}
                            onChange={(e) => setInputDate(e.target.value)}
                            className="px-3 py-1.5 rounded-lg text-xs font-semibold bg-slate-900/60 text-white border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 cursor-pointer"
                        />

                        <button
                            onClick={handleFetch}
                            disabled={!inputDate}
                            className="flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-xs font-bold bg-blue-600 text-white hover:bg-blue-500 disabled:opacity-40 transition-all shadow-sm"
                        >
                            <MagnifyingGlassIcon className="w-3.5 h-3.5" />
                            Get Report
                        </button>

                        {/* Active date pill */}
                        {activeDate && (
                            <div className="ml-auto flex items-center gap-2 px-3 py-1 rounded-full bg-blue-600/20 border border-blue-500/30">
                                <span className="w-1.5 h-1.5 rounded-full bg-blue-400 animate-pulse" />
                                <span className="text-[11px] font-semibold text-blue-300">
                                    Showing: {new Date(activeDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                                </span>
                            </div>
                        )}
                    </div>

                    {/* ── Navigation Tabs ── */}
                    <div className="bg-slate-50/80 border-b border-slate-200 px-6 pt-4">
                        <nav
                            className="flex gap-2 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]"
                            aria-label="Tabs"
                        >
                            {TABS.map((tab) => {
                                const isActive = active === tab.id;
                                return (
                                    <button
                                        key={tab.id}
                                        onClick={() => setActive(tab.id)}
                                        className={`
                                            flex-shrink-0 whitespace-nowrap group relative flex items-center gap-2.5 px-6 py-4 text-sm font-bold transition-all duration-300
                                            rounded-t-xl border-x border-t -mb-px
                                            ${isActive
                                                ? "bg-white border-slate-200 text-blue-600 shadow-[0_-4px_12px_rgba(0,0,0,0.02)]"
                                                : "bg-transparent border-transparent text-slate-500 hover:text-slate-800 hover:bg-slate-200/40"
                                            }
                                        `}
                                    >
                                        <tab.icon className={`w-5 h-5 transition-colors ${isActive ? "text-blue-600" : "text-slate-400 group-hover:text-slate-600"}`} />
                                        {tab.label}
                                        {isActive && (
                                            <span className="absolute top-0 left-0 right-0 h-1 bg-blue-600 rounded-full mx-2" />
                                        )}
                                    </button>
                                );
                            })}
                        </nav>
                    </div>

                    {/* ── Dynamic Content ── */}
                    <div className="relative min-h-[600px]">
                        {renderActiveContent()}
                    </div>

                </div>
            </div>
        </div>
    );
}